module.exports = django;


//////////////////
// WEBPACK FOOTER
// external "django"
// module id = 59
// module chunks = 0